/**
 * @file actions/Tracking/constants.js
 */

export const DEFAULT_TRACKING = {
    type: "",
    title: "",
    description: "",
    trackingId: "",
    contentarea: "",
    contenttype: "",
    subsection1: "",
    subsection2: "",
    subsection3: "",
    subsection4: "",
    department: {},
};
